import React from 'react';
import { AnchorProps } from '@sls-react/components/Links/A';
import { Link } from '@sls-react/routing';

const settingsPages = {
  account: '/settings/account',
  address: '/settings/addresses',
  connectedAccounts: '/settings/integrations',
  notifications: '/settings/notifications',
  payment: '/settings/payment_methods',
  vacation: '/settings/vacation',
  csvImport: '/settings/csv-import',
};

export type SettingsPageLinkPages = keyof typeof settingsPages;

type Props = AnchorProps & {
  page?: SettingsPageLinkPages;
};

const SettingsPageLink: React.FC<Props> = ({
  children,
  page = 'account',
  ...props
}) => (
  <Link href={`${settingsPages[page]}`}>
    <a {...props}>{children}</a>
  </Link>
);

export default SettingsPageLink;
